import { render } from "./addExtras.vue?vue&type=template&id=1fedd1c9&scoped=true"
import script from "./addExtras.vue?vue&type=script&lang=js"
export * from "./addExtras.vue?vue&type=script&lang=js"

import "./addExtras.vue?vue&type=style&index=0&id=1fedd1c9&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fedd1c9"]])

export default __exports__